import { render } from "./EditCategorieActivite.vue?vue&type=template&id=2ccf5b10"
import script from "./EditCategorieActivite.vue?vue&type=script&lang=js"
export * from "./EditCategorieActivite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__